const paymentApplicationUrl = 'https://payment.dev.dokuma.co.zw';

export const environment = {
  production: false,
  payment: {
    iveriApplicationId: 'ea2f7cdd-29bf-4474-93a9-ea56aa6ac4fb',
    iveriGateway: 'https://portal.host.iveri.com/threedsecure/EnrollmentInitial',
    iveriReturnUrl:
      'https://dlap-gateway.dev.dokuma.co.zw/deeds/public/payment/authenticate',
    zimswitchGateway: 'https://eu-prod.oppwa.com/v1/',
    paymentRedirectUrl: `${paymentApplicationUrl}/status/`,
  },
  server: 'https://dlap-gateway.dev.dokuma.co.zw/deeds/',
  portalUrls: {
    deeds: 'https://deeds.v2.dokuma.co.zw',
    bank: 'https://ebanking.v2.dokuma.co.zw',
    lawFirm: 'https://econveyancer.v2.dokuma.co.zw',
    highCourt: 'https://ecourt.v2.dokuma.co.zw',
  },
};
